import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import GuardianPendingPage from "../../auth/GuardianPendingPage";
import { GuardianAdvisoryContext } from "./guardianAdvisory";

// Legacy accounts keep using the app while the guardian verifies. The notice is
// a one-line strip that opens to the full steps, and it shares the viewport
// with the app rather than stacking on top of a full-height screen.
function GuardianAdvisory() {
  const [open, setOpen] = useState(false);
  return (
    <GuardianAdvisoryContext.Provider value={true}>
      <div className="flex h-[100dvh] flex-col">
        <div className="no-print shrink-0 border-b border-amber-200 bg-amber-50 text-sm text-amber-950">
          <div className="flex items-center gap-3 px-4 py-2">
            <p className="min-w-0 flex-1">Tu tutor aún no ha verificado tu cuenta. Puedes continuar usando tu cuenta mientras completas este paso.</p>
            <button type="button" aria-expanded={open} onClick={() => setOpen(value => !value)} className="min-h-11 shrink-0 font-semibold underline">{open ? "Ocultar" : "Ver qué falta"}</button>
          </div>
          {open && <div className="max-h-[50dvh] overflow-y-auto px-4 pb-4"><GuardianPendingPage advisory /></div>}
        </div>
        <div className="min-h-0 flex-1 overflow-y-auto"><Outlet /></div>
      </div>
    </GuardianAdvisoryContext.Provider>
  );
}

export default function GuardianGate() {
  const { authChecked, guardianVerification, guardianStatusLoading, guardianStatusError, refreshGuardianStatus } = useAuth();
  if (!authChecked || guardianStatusLoading) return <p role="status" className="p-6">Consultando la autorización de tu tutor…</p>;
  if (guardianStatusError) return <main className="p-6 space-y-4"><p role="alert">No pudimos consultar la autorización. Inténtalo de nuevo.</p><button type="button" onClick={refreshGuardianStatus} className="min-h-11 underline">Volver a consultar</button></main>;
  if (guardianVerification?.required && guardianVerification?.enforced && guardianVerification.state !== "verified") return <GuardianPendingPage />;
  if (guardianVerification?.required && guardianVerification.state !== "verified") return <GuardianAdvisory />;
  return <Outlet />;
}
